import type { TiptapBody } from "@circle-react/components/QuickPostV3/data/types";
import type { JSONContent } from "@tiptap/react";

const NODE_TYPES_WITHOUT_CONTENT = [
  "image",
  "file",
  "embed",
  "mention",
  "horizontalRule",
];

export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

const isTiptapNode = (value: unknown): value is JSONContent => {
  if (!isRecord(value) || typeof value.type !== "string") return false;
  if (!("content" in value)) return true;

  return Array.isArray(value.content) && value.content.every(isTiptapNode);
};

export const isTiptapBody = (value: unknown): value is TiptapBody => {
  if (!isRecord(value)) return false;
  if (!("body" in value)) return true;
  if (!isRecord(value.body)) return false;
  if (!("content" in value.body)) return true;

  return (
    Array.isArray(value.body.content) && value.body.content.every(isTiptapNode)
  );
};

const hasValidTiptapNode = ({ content, type }: JSONContent) =>
  Boolean(content) ||
  (typeof type === "string" && NODE_TYPES_WITHOUT_CONTENT.includes(type));

export const isValidTiptapBody = (value?: TiptapBody | null): boolean => {
  const content = value?.body?.content;

  return Array.isArray(content) && content.some(hasValidTiptapNode);
};
